import { createGlobalStyle } from "styled-components";
import { defaultButtons } from "./Buttons";
import { defaultHeadings } from "./Headings";
import { defaultImages } from "./Images";
import { defaultLinks } from "./Links";
import { defaultLists } from "./Lists";
import { defaultText } from "./Text";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;

    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.black};
    
    /* SCROLLBAR */
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.white}22;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: ${(props) => props.theme.colors.white}88;
      &:hover {
      background: ${(props) => props.theme.colors.white}99;
      }
    }
  }

  ${defaultHeadings}
  ${defaultButtons}
  ${defaultText}
  ${defaultLinks}
  ${defaultLists}
  ${defaultImages}
`;

export default GlobalStyle;
